/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ damageType: NonNullable<unknown> }} Case_Damage_Type_LabelInputs */

const en_case_damage_type_label = /** @type {(inputs: Case_Damage_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.damageType === "material_damage") return /** @type {LocalizedString} */ (`Material damages`);
	if (i?.damageType === "lost_income") return /** @type {LocalizedString} */ (`Lost income`);
	if (i?.damageType === "medical_hospital_expenses") return /** @type {LocalizedString} */ (`Medical/hospital expenses`);
	if (i?.damageType === "franchise_reimbursement") return /** @type {LocalizedString} */ (`Franchise reimbursement`);
	if (i?.damageType === "other") return /** @type {LocalizedString} */ (`Other`);
	return /** @type {LocalizedString} */ (`${i?.damageType}`)
	
};

const pt_br2_case_damage_type_label = /** @type {(inputs: Case_Damage_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.damageType === "material_damage") return /** @type {LocalizedString} */ (`Danos materiais`);
	if (i?.damageType === "lost_income") return /** @type {LocalizedString} */ (`Lucros cessantes`);
	if (i?.damageType === "medical_hospital_expenses") return /** @type {LocalizedString} */ (`Despesas médico hospitalares`);
	if (i?.damageType === "franchise_reimbursement") return /** @type {LocalizedString} */ (`Ressarcimento de franquia`);
	if (i?.damageType === "other") return /** @type {LocalizedString} */ (`Outro`);
	return /** @type {LocalizedString} */ (`${i?.damageType}`)
	
};

/**
* | damageType | output |
* | --- | --- |
* | "material_damage" | "Material damages" |
* | "lost_income" | "Lost income" |
* | "medical_hospital_expenses" | "Medical/hospital expenses" |
* | "franchise_reimbursement" | "Franchise reimbursement" |
* | "other" | "Other" |
* | * | "{damageType}" |
*
* @param {Case_Damage_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_damage_type_label = /** @type {((inputs: Case_Damage_Type_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Damage_Type_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_damage_type_label(inputs)
	return pt_br2_case_damage_type_label(inputs)
});